export default __webpack_public_path__ + "static/image-20-cbe3aaa0f23786c43a1b631068bfd5b1.jpg";